var React = require('react');

function Pin (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M8 23.29C1.252 13.511 0 12.507 0 8.914a8.914 8.914 0 1117.827 0c0 3.594-1.252 4.6-8 14.376a1.115 1.115 0 01-1.827 0zm.916-10.662A3.714 3.714 0 105.2 8.914a3.714 3.714 0 003.714 3.714z","fill":"currentColor"}));
}

Pin.defaultProps = {"viewBox":"0 0 17.827 23.77"};

module.exports = Pin;

Pin.default = Pin;
